import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./index.css";
import LoginPage from "./pages/LoginPage";
import MainPage from "./pages/MainPage";
import OtpPage from "./pages/OtpPage";
import AllPrescribedData from "./pages/AllPrescribedData";

function App() {
  // Auth Guards
  const RequireAuth = ({ children }) => {
    const isAuthenticated = sessionStorage.getItem("loggedInUserData");
    return isAuthenticated ? children : <Navigate to="/login-page" replace />;
  };
  return (
    <Router basename="/">
      {" "}
      {/* Set the basename to /report-manager */}
      <Routes>
        <Route path="/" element={<Navigate to="/login-page" replace />} />
        <Route path="/login-page" element={<LoginPage />} />
        <Route path="/otp-page" element={<OtpPage />} />

        <Route
          path="/compounder-validate-page"
          element={
            <RequireAuth>
              <MainPage />
            </RequireAuth>
          }
        />
        {/* <Route
          path="/prescribed-list"
          element={
            <RequireAuth>
              <AllPrescribedData />
             </RequireAuth>
          }
        /> */}
      </Routes>
    </Router>
  );
}

export default App;
